
<template>
  <div class="attribute-item-row">
    <div
      v-for="attribute in getItems"
      :key="attribute.attributeKey"
      class="attribute-item pa-3"
    >
      <div class="attribute-item-title">
        {{ attribute.displayName }}
      </div>
      <div class="attribute-item-value mt-3">
        {{ attribute.value }}
      </div>
    </div>
  </div>
</template>

<script>
import { providers as providerEnum } from '@/modules/judicialFees/helpers/enum';

export default {
  name: 'BillAttributes',
  components: {},
  props: {
    attributes: {
      type: Array,
      required: true,
    },
    provider: {
      type: Number,
      required: true,
    },
  },
  data() { return {}; },
  computed: {
    icmsProps() {
      return [
        {
          key: 'CaseCode',
          displayName: this.local.judicialFees.attributes.caseCode,
        },
        {
          key: 'Classification',
          displayName: this.local.judicialFees.attributes.classification,
        },
        {
          key: 'CaseType',
          displayName: this.local.judicialFees.attributes.caseType,
        },
        {
          key: 'CourtName',
          displayName: this.local.judicialFees.attributes.courtName,
        },
        {
          key: 'Circle',
          displayName: this.local.judicialFees.attributes.circle,
        },
      ];
    },
    execProps() {
      return [
        {
          key: 'CaseCode',
          displayName: this.local.judicialFees.attributes.sakCode,
        },
        {
          key: 'Classification',
          displayName: this.local.judicialFees.attributes.classification,
        },
        {
          key: 'CaseType',
          displayName: this.local.judicialFees.attributes.caseType,
        },
        {
          key: 'CourtName',
          displayName: this.local.judicialFees.attributes.courtName,
        },
        {
          key: 'Circle',
          displayName: this.local.judicialFees.attributes.circle,
        },
      ];
    },
    getItems() {
      return this.provider == providerEnum.icms ? this.icmsItems : this.execItems;
    },
    icmsItems() {
      return this.icmsProps.map((prop) => {
        const attribute = this.attributes.find(p => p.attributeKey == prop.key);
        if (attribute) { prop.value = attribute.attributeValue; }
        return prop;
      }).filter(item => item.value);
    },
    execItems() {
      return this.execProps.map((prop) => {
        const attribute = this.attributes.find(p => p.attributeKey == prop.key);
        if (attribute) { prop.value = attribute.attributeValue; }
        return prop;
      }).filter(item => item.value);
    },
  },
  watch: {},
  mounted() { },
  methods: {},

};
</script>

<style lang="scss" scoped>
.attribute-item-row {
  display: flex;
  justify-content: space-between;
  flex: 1;
  position: relative;
}

.attribute-item {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex: 1;
  padding: 0 10px 0 10px;
}

    .attribute-item-title {
        font-size: 14px;
        font-weight: bold;
        color: var(--app-primary-color);
    }

.attribute-item-value {
  font-weight: bolder;
  font-size: 16px;
  color: var(--app-dark-primary-color);
}
</style>
